import * as Yup from "yup";
import BlockModel from "../../models/masters/block-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { SelectField } from "../../core/select-field.component";
import { useGetBlock } from "../../apiclient/master/useGetBlockApi";

interface BlockEditProps {
  data: BlockModel;
  isViewMode?: boolean;
  
  onClose?: (status: SubmitStatus, data: any) => any;
}

const BlockEntry: React.FC<BlockEditProps> = ({ ...props }) => {
  let { data,  onClose ,isViewMode} = props;
  const title = data?.blockId > 0 ? "Edit Block" : "Add Block";
  
  let initialValue: BlockModel = {
    blockId: data?.blockId ? data.blockId : 0,
    name: data?.name,
    districtId: data?.districtId ? data.districtId : 0,
    districtName: data?.districtName,
   
  };
  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("Required"),
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "Block name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 


  });

    const [existingName, setExistingName] = useState<string[]>([]);
    const { data: fetchedBlock } = useGetBlock();



  const [districtData, setDistrictData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDistrict } = useGetDistrict();

  useEffect(() => {
    if (fetchedBlock) {
        setExistingName(fetchedBlock.map((cat: any) => cat.name));
    }


      if (fetchedDistrict) {
          const mappedDistrict = fetchedDistrict.map((district: any) => ({
              value: district.districtId.toString(),
              label: district.name,
          }));
          setDistrictData(mappedDistrict);
      }
  }, [fetchedDistrict,fetchedBlock]);

  
  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Block/SaveBlock"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.blockId>0? true: false}
      >
          <div>
            <div className="row">
              <div className="col-6">
              <InputField maxLength={10} label="Block *" name="name" />
            </div>
            <div className="col-6">
            <SelectField
                                label="District"
                                name="districtId"
                                options={districtData}
                                unSelectValue={0}
                            />       
                                 </div>
                
              
            </div>
          </div>
        
      </FormikModelDialog>
    </>
  );
};

export default BlockEntry;
